export { getScreenName } from "./aopScreenNames";

const mixpanelEvents = {
  SCREEN_LOAD: "screen_load",
  CTA_CLICKED: "cta_clicked",
  FORM_CLICKED: "form_clicked",
  ERROR_TRIGGERED: "error_triggered",
};

export default mixpanelEvents;

export const webFlowEvents = {
  otp: {
    INITIATED: "lead_otp_initiated",
    SUCCESS: "lead_otp_success",
    ERROR: "lead_otp_error",
  },
  pan: {
    SUCCESS: "pan_dob_step_success",
    ERROR: "pan_dob_step_error",
  },
  bank: {
    SUCCESS: "bank_details_step_completed",
    ERROR: "bank_details_step_error",
  },
  eSign: {
    SUCCESS: "esign_step_completed",
    KRA_SUCCESS: "esign_kra_step_completed",
  },
  finalSubmission: {
    SUBMITTED: "account_opening_submitted",
  },
};
